
// ----------------  custome add to cart -------------------

let isCartUpdating = false;

document.addEventListener('click', function (e) {
const btn = e.target.closest('.add-to-cart-btn');

if (!btn) return;

// Preorder cards render <a href="{{ product.url }}"> with class
// add-to-cart-btn--preorder so the customer is routed to the PDP
// (where Essential Pre-Order's form handles the queue correctly).
// Let the browser follow the link — do NOT call /cart/add.js with
// the undefined variant id, which silently no-ops and opens an
// empty cart drawer.
if (btn.classList.contains('add-to-cart-btn--preorder')) return;

// Multi-variant cards (Vitamax, GlucoXtra) render <a href="{{ product.url }}">
// with add-to-cart-btn--choose ("Læs mere") to send the customer to the PDP
// where the 240/720 size picker lives. Same reasoning as preorder above:
// don't hijack the click into /cart/add.js with an undefined variant id,
// which no-ops and opens an empty cart drawer. Let the link navigate.
if (btn.classList.contains('add-to-cart-btn--choose')) return;

e.preventDefault();

// 🔴 STOP multiple requests
if (isCartUpdating) return;
isCartUpdating = true;

btn.classList.add('loading');
btn.style.pointerEvents = 'none';

let variantId = btn.dataset.variantId;
let sellingPlanId = btn.dataset.sellingPlanId;

// Build payload; include selling_plan only when the button explicitly
// declares one (e.g. SUBSCRIBE & SAVE buttons on /pages/subscribe).
let payload = { id: variantId, quantity: 1 };
if (sellingPlanId) {
    payload.selling_plan = sellingPlanId;
}

fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
})
    .then(() => {
    // ✅ Only ONE drawer request
    return fetch('/cart?section_id=cart-drawer');
    })
    .then((res) => res.text())
    .then((html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newInner = doc.querySelector('#CartDrawer .drawer__inner');
    const currentInner = document.querySelector('#CartDrawer .drawer__inner');

    if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
    }

    document.querySelector('cart-drawer')?.open();

    // 🟡 IMPORTANT: Delay upsell (avoid spam)
    setTimeout(() => {
        if (typeof loadUpsells === 'function') {
        loadUpsells();
        }
    }, 500);
    })
    .catch((err) => {
    console.error('Cart error:', err);
    })
    .finally(() => {
    isCartUpdating = false;
    btn.classList.remove('loading');
    btn.style.pointerEvents = 'auto';
    });
});



// -------------------- upgrade-subscription ----------------

if (typeof window.isUpdatingSubscription === 'undefined') {
  window.isUpdatingSubscription = false;
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.upgrade-subscription');
  if (!btn) return;

  e.preventDefault();

  // 🔴 prevent multiple clicks
  if (window.isUpdatingSubscription) return;
  window.isUpdatingSubscription = true;

  const line = btn.dataset.line;
  const plan = btn.dataset.plan;

  const label = btn.querySelector('.upgrade-label');
  const loader = btn.querySelector('.upgrade-loading');

  if (label) label.style.display = 'none';
  if (loader) loader.style.display = 'flex';

  /* ===============================
     CHANGE TO SUBSCRIPTION
  ============================== */
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      line: line,
      selling_plan: plan
    })
  })
  .then((res) => {
    if (!res.ok) throw new Error('Subscription update failed');
    return res.json();
  })

  /* ===============================
     REFRESH CART DRAWER
  ============================== */
  .then(() => {
    return fetch('/cart?section_id=cart-drawer');
  })
  .then((res) => res.text())

  .then((html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newDrawer = doc.querySelector('#CartDrawer');
    const currentDrawer = document.querySelector('#CartDrawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.open();
     setTimeout(() => {
        if (typeof loadUpsells === 'function') {
        loadUpsells();
        }
    }, 500);

    // ✅ overlay click fix
    const overlay = document.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.onclick = function () {
        document.querySelector('cart-drawer').close();
      };
    }
  })

  .catch((err) => {
    console.error('Subscription Error:', err);
  })

  .finally(() => {
    window.isUpdatingSubscription = false;

    if (label) label.style.display = 'inline';
    if (loader) loader.style.display = 'none';
  });
});

// -------------- subscription-plan ---------

document.addEventListener('change', function (e) {
    const select = e.target.closest('.subscription-plan');
    if (!select) return;

    let id = select.dataset.id;
    let plan = select.value;

    let body = { id: id };

    if (plan) {
        body.selling_plan = plan;
    } else {
        body.selling_plan = null;
    }

    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
    .then((res) => res.json())
    .then(() => fetch('/?section_id=cart-drawer'))
    .then((res) => res.text())
    .then((html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newInner = doc.querySelector('#CartDrawer .drawer__inner');
    const currentInner = document.querySelector('#CartDrawer .drawer__inner');

    if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
    }

    const drawer = document.querySelector('cart-drawer');

    if (drawer) {
        drawer.open();
    }
    setTimeout(() => {
        if (typeof loadUpsells === 'function') {
        loadUpsells();
        }
    }, 500);
    // ✅ overlay click close fix
    const overlay = document.querySelector('#CartDrawer-Overlay');
    if (overlay) {
        overlay.addEventListener('click', function () {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
            drawer.close();
        }
        });
    }
    })
    .catch((err) => console.log('cart update error:', err));
});